import React from 'react';
import { useEffect } from "react";
import Testimonials from "../Home/Testimonials";
import Objectives from "./Objectives";
import Strategy from "./Strategy";

const DigitalTransformation = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className="transformation-banner bg-center">
        <div className="w-full 2xl:container mx-auto lg:px-16 md:px-8 px-5 flex items-center h-full">
          <h1 className="font-montserrat lg:text-6xl md:text-5xl text-4xl font-semibold text-white">
            Digital <br /> Transformation
          </h1>
        </div>
      </div>
      <div className="2xl:container mx-auto lg:px-16 md:px-8 px-5 py-16 xl:w-[85%] flex flex-col items-center">
        <p className="text-dark-green text-center font-raleway text-xl font-medium tracking-[6.6px]">
          Case Studies
        </p>
        <h2 className="font-raleway lg:text-4xl md:text-3xl text-2xl font-semibold text-white mt-5 text-center">
          Digital Transformation
        </h2>
        <div className="mt-12 w-full">
          <h3 className="text-primary font-raleway md:text-4xl text-3xl font-semibold">
            Overview
          </h3>
          <p className="mt-5 text-white font-raleway md:text-xl text-lg">
            This case study details the transformation of a traditional bank
            into a data-driven powerhouse through digital innovation. By
            integrating data analytics, IoT, and embracing service-oriented
            models, the bank has revolutionized conventional practices.
            <br />
            <br />
            This evolution has empowered the bank to provide highly tailored
            services to its customers. In the realm of banking operations, the
            institution deployed IoT sensors to capture real-time data on
            transactions and customer behaviors. Leveraging advanced analytics,
            the bank can proactively detect fraud, offer personalized financial
            insights, and optimize operational efficiency. This data-driven
            approach not only fortifies security but also elevates customer
            experience, positioning the bank as a leader in the dynamic
            landscape of modern finance.
          </p>
        </div>
      </div>
      <Objectives />
      <Strategy />
      <div className="it-service my-10">
        <div className="2xl:container mx-auto px-10 h-full flex items-center justify-center">
          <h3 className="text-white font-raleway lg:text-4xl sm:text-2xl text-xl font-semibold text-center">
            We run all kinds of{" "}
            <span className="text-primary">IT services</span>{" "}
            that vows your success
          </h3>
        </div>
      </div>
      <Testimonials />
    </>
  );
};

export default DigitalTransformation;
